export { computeAutoPlacement } from './computeAutoPlacement';
export { getBordersSize } from './getBordersSize';
export { getBoundaries } from './getBoundaries';
export { getBoundingClientRect } from './getBoundingClientRect';
export { getClientRect } from './getClientRect';
export { getOffsetParent } from './getOffsetParent';
export { getOffsetRectRelativeToArbitraryNode } from './getOffsetRectRelativeToArbitraryNode';
export { getOffsets } from './getOffsets';
export { getOppositePlacement } from './getOppositePlacement';
export { getOppositeVariation } from './getOppositeVariation';
export { getOuterSizes } from './getOuterSizes';
export { getParentNode } from './getParentNode';
export { getReferenceOffsets } from './getReferenceOffsets';
export { getScroll } from './getScroll';
export { getScrollParent } from './getScrollParent';
export { getStyleComputedProperty } from './getStyleComputedProperty';
export { getTargetOffsets } from './getTargetOffsets';
export { getWindowSizes } from './getWindowSizes';
export { isFixed } from './isFixed';
export { isModifierEnabled } from './isModifierEnabled';
export { isNumeric } from './isNumeric';
export { updateContainerClass } from './updateContainerClass';
export { setStyles } from './setStyles';
